import { Button, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setNewbuildingBrokerCallbackWidgetOpened } from 'shared/actions/newbuildingBrokerOfferBooking/actions';
import { NewbuildingBrokerGalleryBanner } from 'shared/components/NewbuildingBrokerGalleryBanner';
import { selectFullscreenGalleryOpened } from 'shared/selectors/gallery';

import { useOfferBookingUrl } from './hooks/useOfferBookingUrl';

export const NewbuildingBrokerGalleryBannerContainer = () => {
  const isFullscreen = useSelector(selectFullscreenGalleryOpened);
  const offerBookingUrl = useOfferBookingUrl();

  const dispatch = useDispatch();

  const handleDetailsClick = React.useCallback(() => {
    dispatch(setNewbuildingBrokerCallbackWidgetOpened(true));
  }, [dispatch]);

  return (
    <NewbuildingBrokerGalleryBanner
      isFullscreen={isFullscreen}
      buttons={
        <>
          <Button theme="stroke_primary" onClick={handleDetailsClick}>
            Узнать подробности
          </Button>
          <LinkButton theme="fill_primary" href={offerBookingUrl}>
            Заполнить заявку
          </LinkButton>
        </>
      }
    />
  );
};
